import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { CancelIconBlack } from "../../../../../constant/imagePath";
import { isMobileViewHook } from "../../../../../CustomHooks/isMobileViewHook";
import Colors from "../../../../../stories/assets/Colors";
import Fonts from "../../../../../stories/assets/Fonts";
import { CoachAvailablityCard } from "../../../../../stories/CoachAvailablityCard/CoachAvailablityCard";
import ModalSkeleton from "../../../../ModalSkeleton/ModalSkeleton";
import modalClasses from "../../../../ModalSkeleton/ModalSkeleton.module.css";
import classes from "./CoachAvailibility.module.css";

const CoachAvailibility = ({ show, setShow }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  console.log(isMobile, "isMobile");
  return (
    <>
      <style>{`
      .modal-body{
        padding:0;
      }
      .modal-content{
        border-radius:20px !important;
      }
      @media (max-width:992px){
        .modal .modal-dialog {
          width: 100% !important;
          margin: 0px !important;
        }
        .modal .modal-dialog {
          max-width: 100% !important;
          height: 100%;
      }
      .modal-content{
          min-height:100%;
          border-radius:0px !important;
          border:none
      }
      .modal { 
          border-radius: 0px;
          background: white;
        }
      }
    `}</style>
      <ModalSkeleton
        show={show}
        setShow={setShow}
        hideHeaderBorder
        width={"561px"}
      >
        <div className={[classes.contentHeight]}>
          {isMobile && (
            <div
              style={{
                borderBottom: `1px solid ${Colors.neutralShadesOfGainsboro}`,
              }}
              className={[classes.FilterHeader].join(" ")}
            >
              <ReactSVG src={CancelIconBlack} onClick={() => setShow(false)} />

              <h6
                style={{
                  ...Fonts.b3,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                Full Availability
              </h6>
              <div />
            </div>
          )}
          <div>
            <CoachAvailablityCard />
          </div>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default CoachAvailibility;
